
/*
	Performs a deep merge of a 'patches' data tree into 'base'.
	NOT merging arrays.
*/

export function merge<T extends Record<string,unknown>>(base:T,patch:Partial<T>): T
{
	const ret = {} as T;
	mergeChildren(ret,base,patch);
	return ret;
}

/*
									PATCH
						undef       basic       object
					+-----------+-----------+-----------+
			undef	|    N/A    | use patch | use patch |
	BASE	basic	| use base  | use patch | use patch |
			object	| use base  | use patch |  recurse  |
					+-----------+-----------+-----------+
*/

function mergeChildren(ret:Record<string,unknown>,base:Record<string,unknown>,patch:Record<string,unknown>)
{
	const keys = Object.keys({...base, ...patch});

	for (const key of keys) 
		if (typeof base[key]=='object' && typeof patch[key]=='object') {
			ret[key] = {};
			mergeChildren(ret[key],base[key],patch[key]);
		}
		else if (patch[key] === undefined)
			ret[key] = base[key];
		else 
			ret[key] = patch[key];
}


